import React from "react";
import FetchFeedback from "../ui/CustomFetchFeedback/CustomFetchFeedback";
import MerchantProfileSkeleton from "../ui/Skeletons/MerchantProfileSkeleton";
import useCompanyDetailsData from "./components/hooks/useCompanyDetailsData";
import CompanyDetailsContent from "./CompanyDetailsContent";

const CompanyDetailsPage = () => {
  const { merchantProfile, isLoading, isError, refetch } =
    useCompanyDetailsData();

  if (isLoading) {
    return <MerchantProfileSkeleton />;
  }

  if (isError) {
    return (
      <FetchFeedback
        message="Failed to load company details. Please try again."
        onRetry={refetch}
        fullHeight
      />
    );
  }

  return <CompanyDetailsContent merchantProfile={merchantProfile} />;
};

export default CompanyDetailsPage;
